'use strict';

var userTypes = require('./userTypes');
var eventTypes = require('./eventType');
exports.perGuestBudgets = ['$50-$100', '$101-$150', '$151-$200', '$201-$300', '$301+'];

exports.LEAD_BUDGET_MAP = {
  '$35-$75': 55,
  '$76-$125': 100,
  '$126-$200': 165,
  '$201+': 250
};

exports.mealTypes = ['Breakfast', 'Brunch', 'Lunch', 'Dinner', 'Standing Cocktail Party', 'Cocktail Party + Dinner', 'Other'];

exports.eventStyles = ['Seated', 'Standing', 'Seated + Standing'];

exports.occasions = eventTypes.filter(function (type) {
  return type.visible;
}).map(function (occasion) {
  return occasion.label;
});

exports.privacyTypes = ['Fully Private', 'Practically Private', 'Semi-private', 'Communal', 'Whole Restaurant'];

exports.heardAbout = ['Search Engine', 'Colleague', 'Venue Referral', 'Social Media', 'Friend'];

exports.adminHeardAbout = exports.heardAbout.concat('Business Development');

exports.avOptions = ['TV', 'Screen', 'Projector', 'Microphone', 'Podium', 'Other'];

var nonCityRoles = ['Host', 'Admin', 'Closer', 'PrimaryAssignee', 'Venue Acquisition', 'Profile Creation', 'OOM Admin', 'Venue Admin'];

exports.adminCities = Object.keys(userTypes).filter(function (type) {
  return nonCityRoles.indexOf(type) === -1;
});

exports.conciergeFormCities = ['New York', 'DC Metro Area', 'Boston Area', 'Chicago', 'San Francisco Bay Area', 'Greater Los Angeles', 'Miami'];

exports.defaultCity = 'New York';

exports.priorityLevels = ['Low', 'Medium', 'High', 'Urgent'];

exports.availabilities = ['Not Inquired', 'Inquired', 'Available', 'Not Available', 'Booked (Offline)', 'Cancelled'];

exports.killReasons = ['Bad Fit for SixPlus', 'Event Cancelled', 'Request For Another City', 'Location Where We Don\'t Have Venues', 'Invalid Email and No Phone Number', 'Venue Client Wanted NA', 'Fake or Duplicate Inquiry', 'Went with Catering', 'Pandemic, Disaster, etc.'];

exports.lostReasons = ['Client Found Other Venue w/o SixPlus', 'Client No Response', 'Client Says \'No Thank You\'', 'Client Booked Recommended Venue w/o SixPlus', 'Same Day Booking Request', 'We Dropped the Ball', 'Event Transferred To A Colleague Who Booked Elsewhere', 'Unresponsive Venue'];

exports.archiveReason = ['Event Cancelled', 'Event Postponed', 'I Found Another Venue (Off SixPlus)', 'I Booked A Venue Offline', 'Went with Catering', 'Other / Prefer Not To Say'];

exports.closeReasons = exports.lostReasons.concat(exports.killReasons);

exports.closeAndArchiveReason = exports.closeReasons.concat(exports.archiveReason.filter(function (reason) {
  return exports.closeReasons.indexOf(reason) < 0;
}));

exports.LEAD_SOURCE_VENUE = 'Venue Proposal';
exports.LEAD_SOURCE_CONCIERGE = 'Concierge Form';
exports.LEAD_SOURCE_ADMIN = 'Admin Concierge Form';
exports.LEAD_SOURCE_DER = 'DER';
exports.LEAD_SOURCE_SHELL = 'Client';

exports.leadCreatedThrough = [exports.LEAD_SOURCE_ADMIN, exports.LEAD_SOURCE_CONCIERGE, exports.LEAD_SOURCE_VENUE, exports.LEAD_SOURCE_DER, exports.LEAD_SOURCE_SHELL];

exports.recommendationCreatedThrough = ['Event Request', 'Proposal', 'Concierge', 'Recos Venue Search', 'Client'];